// De que tipo é o arquivo de uma mensagem.
//
// A categoria sai da EXTENSÃO real, não do `mediaType` do banco: ele vem de
// fonte diferente conforme o canal ("application" no envio, "document" na
// importação, o tipo cru do whaileys em mensagens antigas) e PDF já apareceu
// gravado das três formas. É a mesma regra do backend
// (services/MessageServices/ListTicketMediaService.ts) — as duas pontas
// precisam concordar, senão a grade mostra numa categoria e o ZIP guarda em
// outra pasta.
const POR_EXTENSAO = {};

const registrar = (categoria, lista) =>
  lista.forEach((ext) => {
    POR_EXTENSAO[ext] = categoria;
  });

registrar("imagem", [
  ".jpg",
  ".jpeg",
  ".jfif",
  ".png",
  ".gif",
  ".webp",
  ".bmp",
  ".heic",
  ".heif",
  ".svg",
  ".tif",
  ".tiff",
  ".avif",
]);
registrar("video", [".mp4", ".3gp", ".mov", ".avi", ".mkv", ".webm", ".m4v"]);
registrar("audio", [
  ".ogg",
  ".opus",
  ".mp3",
  ".m4a",
  ".wav",
  ".aac",
  ".amr",
  ".oga",
]);

export const extensaoDe = (url) => {
  if (!url) return "";

  // A URL pode trazer query string (?token=…) e o nome vem codificado.
  const semQuery = String(url).split("?")[0].split("#")[0];
  const nome = decodeURIComponent(semQuery.split("/").pop() || "");
  const ponto = nome.lastIndexOf(".");

  return ponto > 0 ? nome.slice(ponto).toLowerCase() : "";
};

export const categoriaDoArquivo = (url, mediaType) => {
  const extensao = extensaoDe(url);

  if (POR_EXTENSAO[extensao]) return POR_EXTENSAO[extensao];

  const tipo = String(mediaType || "").toLowerCase();
  if (tipo.startsWith("image") || tipo === "sticker") return "imagem";
  if (tipo.startsWith("video")) return "video";
  if (tipo.startsWith("audio") || tipo === "ptt") return "audio";

  return "documento";
};

// O que o navegador consegue exibir por conta própria. Word, Excel e
// PowerPoint não entram: nenhum navegador os renderiza, e um <iframe> apontado
// para eles mostra uma página em branco ou dispara download — pior que dizer
// com todas as letras que ali só dá para baixar.
export const dáParaVisualizar = (url, mediaType) => {
  const categoria = categoriaDoArquivo(url, mediaType);

  if (categoria !== "documento") return true;

  return [".pdf", ".txt", ".csv", ".log", ".json", ".xml"].includes(
    extensaoDe(url),
  );
};

export default categoriaDoArquivo;
